export default __webpack_public_path__ + "static/media/ringtone.88b2a965.ogg";